import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {DataStoreService} from './data-store.service';
import {Style} from './style';
import {environment} from '../../environments/environment';
import {extractData} from './utils';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class StylesService extends DataStoreService<Style> {

  constructor(private http: Http) {
    super();
  }

  fetchAll$(): Observable<Style[]> {
    return this.http.get(`${environment.apiUrl}/admin/styles`).map(extractData).map((rawStyles: IRawStyle[]) => {
      return mapStyles(rawStyles);
    })
  }
}

export interface IRawStyle {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}

export function mapStyles(rawStyles: IRawStyle[]) {
  return rawStyles.map((rawStyle: IRawStyle) => new Style(rawStyle.id, rawStyle.name, rawStyle.updated_at, rawStyle.created_at));
}



// WEBPACK FOOTER //
// ./src/app/services/styles.service.ts